import React from "react";

export default function MainTitle({ title }: { title: string }) {
  return (
    <h1 className="font-pprightgothic text-white text-[30px] lg:text-[40px] xl:text-[60px] mb-5 leading-tight">
      {title}
    </h1>
  );
}
